import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";
import { COLOR_CONSTANTS } from "constants/StyleConstants";
import { TYPOGRAPHY_VARIANTS } from "components/v3/Theme/TypographyVariants";
import checkIcon from "assets/icons/Check.svg";
import arrowRightIcon from "assets/icons/arrow-right.svg";
import aboutYouIcon from "assets/icons/about-you.svg";

// Some of these could be moved to styles for their respective
//  question types if this gets too big in here
const SurveyWrapperStyles = makeStyles((theme?: any) => ({
  loadingContainer: {
    height: "50vh"
  },
  pageProgressContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "8px",
    borderRadius: "24px 24px 0 0",
    overflow: "hidden",
    zIndex: 2,
    backgroundColor: COLORS.SECONDARY_LIGHTEST
  },
  pageProgressFade: {
    position: "absolute",
    top: "8px",
    left: 0,
    right: "15px",
    height: "10px",
    background:
      "linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,0) 100%)",
    zIndex: 1
  },
  pageProgressBar: {
    height: "100%",
    backgroundColor: "transparent",
    "& .MuiLinearProgress-bar": {
      backgroundColor: COLORS.ACCENT3,
      borderRadius: "0"
    }
  },
  surveyContainer: {
    boxSizing: "border-box",
    flex: 1,
    "--background-dim": "#FFF",
    "--font-family": "Inter, sans-serif",
    "--primary": "#000",
    "--sjs-default-font-family": "Inter, sans-serif",
    "--sjs-font-family": "Inter, sans-serif",
    fontFamily: "Inter, sans-serif",
    marginBottom: "50px !important",
    "& p, & .sd-html, & .sd-html p, & .sd-html li, & .sv-popup__body-header": {
      fontFamily: "Inter, sans-serif"
    },

    "& .colon-cancer-contact-header-icon": {
      display: "block",
      height: 128,
      width: 128,
      marginBottom: 16
    },

    "& .gl-mint-bubble": {
      backgroundColor: COLORS.ACCENT3_LIGHTER,
      borderRadius: "4px 16px 16px 16px",
      lineHeight: "25px",
      marginBottom: 16,
      padding: "20px 24px",
      "& h3": {
        color: `${COLORS.BLACK} !important`,
        margin: "0 0 20px 0"
      },
      "& p": {
        margin: "0 0 20px 0",
        "&:last-child": {
          marginBottom: 0
        }
      },
      "& ul": {
        margin: "8px 0 0",
        paddingLeft: "20px"
      },
      "& li": {
        marginBottom: "4px"
      }
    },

    "& .sd-root-modern__wrapper": {
      marginTop: "10px"
    },

    "& .sd-footer": {
      paddingTop: "50px !important",
      [theme.breakpoints.down("lg")]: {
        paddingRight: "5px !important"
      }
    },
    "& .sd-panel__content": {
      paddingTop: "40px"
    },
    "& .sd-container-modern": {
      borderRadius: "24px",
      height: "calc(100vh - 180px)", // Adjust the 120px offset as needed for your layout
      overflowY: "auto",
      position: "relative",
      paddingTop: "20px", // Space for progress bar
      paddingBottom: "20px", // Space at bottom
      [theme.breakpoints.up("sm")]: {
        paddingLeft: "24px",
        paddingRight: "24px"
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: "32px",
        paddingRight: "32px"
      },

      "& .sd-title.sd-element__title span": {
        ...TYPOGRAPHY_VARIANTS.body_strong_lg,
        fontWeight: "700 !important",
        fontSize: "1.25rem !important"
      },
      "& .sd-title.sd-element__title em, & .sd-title.sd-element__title i": {
        fontStyle: "italic",
        fontWeight: 600
      },
      "& .sd-description, & .sd-question__description": {
        ...TYPOGRAPHY_VARIANTS.body_sm_dark_gray,
        color: `${COLORS.DARK_GRAY} !important`,
        fontSize: "0.875rem !important",
        fontWeight: "400 !important",
        lineHeight: "125% !important",
        marginTop: "4px"
      },
      "& .sd-element__header::after": {
        width: "100%",
        background: "#CCCCCC",
        insetInlineStart: "auto"
      },
      "& .gl-question-root h4": {
        margin: "0 0 10px 0",
        ...TYPOGRAPHY_VARIANTS.body_lg1_primary
      },
      "& .sd-html.gl-question-root > p:first-of-type, & .sd-html.gl-question-root > p:first-of-type strong":
        {
          fontFamily: "Inter, sans-serif",
          fontSize: "20px !important",
          fontWeight: "700 !important",
          lineHeight: "150%"
        },
      "& .sd-panel__title span": {
        ...TYPOGRAPHY_VARIANTS.body_strong,
        fontWeight: "700 !important",
        color: `${COLORS.PRIMARY} !important`,
        fontSize: "32px !important"
      },

      "& .about-you-icon": {
        width: "130px",
        height: "130px",
        backgroundImage: `url(${aboutYouIcon})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left",
        margin: "0 0 30px 0",
        display: "block"
      },

      "& .no-margin": {
        margin: "5px 0 5px 0"
      },

      "& .sd-body": {
        maxWidth: "none",
        overflowX: "hidden",
        padding: "0px",
        "@media (max-width: 400px)": {
          padding: "0px 12px 0 8px"
        }
      },
      "& .sd-row.sd-page__row:not(.sd-row--compact) ~ .sd-row.sd-page__row:not(.sd-row--compact)":
        {
          marginTop: "calc(5 * (var(--sjs-base-unit, var(--base-unit, 8px))))"
        },
      // Custom scrollbar styling to avoid progress bar overlap
      "&::-webkit-scrollbar": {
        width: "8px"
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
        marginTop: "15px", // Space for progress bar
        marginBottom: "20px" // Space at bottom
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#ccc",
        borderRadius: "4px"
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#999"
      },
      "& h2": {
        color: COLORS.BLACK,
        fontFamily: "Inter, sans-serif",
        fontSize: "20px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "125%",
        letterSpacing: "-0.5px"
      },
      "& h3": {
        color: COLORS.PRIMARY,
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "150%",
        marginBottom: "5px",
        marginTop: "22px"
      },
      "& i": {
        color: COLORS.DARK_GRAY,
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        fontStyle: "italic",
        fontWeight: 600,
        lineHeight: "125%"
      },
      "& ul": {
        color: "#000",
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "150%",
        paddingLeft: "24px",
        marginTop: "0px",
        marginBottom: "0px"
      },
      "& .small": {
        color: COLORS.DARK_GRAY,
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "1.2",
        marginTop: "5px"
      },
      "& .strong": {
        fontWeight: 600
      },
      "& .close": {
        marginTop: "-12px"
      },
      "& .distant": {
        marginTop: "20px"
      },
      "& a": {
        fontWeight: 600,
        textDecoration: "none"
      }
    },
    "& .sd-root-modern": {
      borderRadius: "10px",
      "& .sd-navigation__next-btn, .sd-navigation__complete-btn": {
        alignItems: "center",
        backgroundColor: COLORS.PRIMARY,
        borderRadius: "8px",
        cursor: "pointer",
        display: "flex",
        gap: "8px",
        justifyContent: "center",
        margin: 0,
        padding: "8px 24px",
        transition: "background-color 0.3s ease, border-radius 0.3s ease",
        textTransform: "none",
        width: "fit-content",
        [theme.breakpoints.down("lg")]: {
          ...TYPOGRAPHY_VARIANTS.body_strong_white
        },
        [theme.breakpoints.up("lg")]: {
          ...TYPOGRAPHY_VARIANTS.body_strong_lg_white
        },
        "&:hover": {
          backgroundColor: COLORS.PRIMARY_DARK,
          borderRadius: "16px 8px 16px 16px"
        },
        "&:disabled": {
          backgroundColor: COLORS.GRAY,
          color: COLORS.DARK_GRAY
        }
      },
      "& .sd-navigation__next-btn": {
        backgroundImage: `url(${arrowRightIcon})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 15px center",
        backgroundSize: "20px 20px",
        paddingRight: "48px",
        marginLeft: "auto",
        alignSelf: "flex-end"
      },
      "& #sv-nav-next, & #sv-nav-complete": {
        display: "flex",
        justifyContent: "flex-end",
        marginLeft: "auto"
      },
      "& #sv-nav-next .sv-action__content, & #sv-nav-complete .sv-action__content":
        {
          display: "flex",
          justifyContent: "flex-end"
        },

      "& .sd-navigation__prev-btn, .sd-navigation__prev-btn:hover": {
        background: "none",
        border: 0,
        boxShadow: "none",
        display: "block",
        padding: 0,
        ...TYPOGRAPHY_VARIANTS.body_strong_accent1_darker
      },
      "& .sv-action, .sv-action__content": {
        width: "fit-content"
      },
      "& .sd-navigation__complete-btn": {
        alignSelf: "flex-end",
        backgroundImage: `url(${arrowRightIcon})`,
        backgroundPosition: "right 15px center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "20px 20px",
        marginLeft: "auto",
        paddingRight: "48px"
      },
      "& .sd-paneldynamic": {
        "& button:not(.sd-action--negative)": {
          color: COLOR_CONSTANTS.COLOR_SUCCESS
        }
      },
      // Kit informed-consent docs use CustomPanelRenderer (panel-intro / panel-intro-*).
      "& .terms-scrollable-panel": {
        marginBottom: "16px"
      },
      "& .terms-scrollable-panel .button, & .sd-html .button": {
        backgroundColor: "#336AB3",
        color: "white",
        textDecoration: "none",
        padding: "10px 20px",
        whiteSpace: "nowrap",
        display: "inline-block"
      },
      "& .gl-radio-option-grid": {
        margin: "0 auto",
        padding: "16px 0",
        "& .gl-radio-option-grid-container": {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "16px",
          width: "100%",
          boxSizing: "border-box",
          "@media (max-width: 768px)": {
            gridTemplateColumns: "repeat(2, 1fr)"
          }
        },
        "& .gl-radio-option-card": {
          cursor: "pointer",
          borderRadius: "12px",
          backgroundColor: "#F2F7FB",
          border: "3px solid transparent",
          transition: "all 0.15s ease",
          minHeight: "140px",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          "&:hover": {
            borderRadius: "10px",
            border: "3px solid #7DB7E1",
            backgroundColor: "#F2F7FB",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
          },
          "&.gl-radio-option-card--selected": {
            borderColor: COLORS.PRIMARY,
            backgroundColor: "#E6F3FF",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)"
          }
        },
        "& .gl-radio-option-card-content": {
          padding: "20px",
          textAlign: "center",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          overflow: "visible"
        },
        "& .gl-radio-option-icon": {
          width: "48px",
          height: "48px",
          borderRadius: "8px",
          marginBottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "20px",
          fontWeight: "bold"
        },
        "& .gl-radio-option-title": {
          ...TYPOGRAPHY_VARIANTS.body_strong,
          fontWeight: 700,
          color: COLORS.BLACK,
          marginBottom: "12px",
          margin: "0 0 8px 0",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          hyphens: "auto",
          minWidth: 0,
          width: "100%",
          textAlign: "center"
        },
        "& .gl-radio-option-description": {
          ...TYPOGRAPHY_VARIANTS.body_sm,
          color: COLORS.DARK_GRAY,
          lineHeight: "1.4",
          margin: 0,
          wordWrap: "break-word",
          overflowWrap: "break-word",
          hyphens: "auto",
          minWidth: 0,
          width: "100%",
          textAlign: "center",
          whiteSpace: "normal",
          overflow: "visible"
        },
        "& .gl-radio-option-grid-display": {
          "& h4": {
            ...TYPOGRAPHY_VARIANTS.body_strong,
            color: COLORS.BLACK,
            marginBottom: "8px"
          },
          "& p": {
            ...TYPOGRAPHY_VARIANTS.body_sm,
            color: COLORS.DARK_GRAY,
            margin: 0
          }
        }
      }
    },
    "& .gl-blue-card": {
      backgroundColor: COLORS.ACCENT1_LIGHTEST,
      borderRadius: "12px",
      padding: "30px 20px",
      margin: "16px 0",
      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.05)",
      maxWidth: "550px",
      "& p": {
        margin: "0 0 12px 0",
        "&:last-child": {
          marginBottom: 0
        }
      },
      "& a": {
        fontWeight: 600,
        textDecoration: "underline !important",
        "&:hover": {
          color: COLORS.ACCENT1_DARKER
        }
      }
    },
    // Boolean (glboolean) — sitewide via registerGlBoolean
    "& .glboolean": {
      margin: 0,
      width: "245px"
    },
    "& .glboolean__row": {
      alignItems: "center",
      border: `1px solid ${COLORS.PRIMARY_LIGHTER}`,
      borderRadius: "4px",
      boxSizing: "border-box",
      display: "flex",
      gap: "14px",
      justifyContent: "center",
      padding: "14px",
      width: "100%"
    },
    "& .glboolean__option": {
      alignItems: "center",
      background: "transparent",
      border: "1.5px solid transparent",
      borderRadius: "4px",
      boxSizing: "border-box",
      cursor: "pointer",
      display: "flex",
      gap: "12px",
      minHeight: "40px",
      padding: "5px 20px",
      transition: "background-color 0.15s ease, border-color 0.15s ease",
      "&:disabled": {
        cursor: "default"
      },
      "&:not(.glboolean__option--selected):not(:disabled):hover .glboolean__radio":
        {
          borderColor: COLORS.PRIMARY_LIGHT
        },
      "&.glboolean__option--selected": {
        backgroundColor: COLORS.PRIMARY_LIGHTEST,
        borderColor: COLORS.PRIMARY_40,
        "&:hover": {
          backgroundColor: COLORS.PRIMARY_LIGHTEST,
          borderColor: COLORS.PRIMARY_40
        }
      }
    },
    "& .glboolean__check": {
      backgroundColor: COLORS.PRIMARY_40,
      backgroundImage: `url(${checkIcon})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "14px 14px",
      borderRadius: "50%",
      boxSizing: "border-box",
      flexShrink: 0,
      height: "16px",
      width: "16px"
    },
    "& .glboolean__radio": {
      border: "2px solid #CBD2E0",
      borderRadius: "50%",
      boxSizing: "border-box",
      flexShrink: 0,
      height: "16px",
      transition: "border-color 0.15s ease",
      width: "16px"
    },
    "& .glboolean__label": {
      ...TYPOGRAPHY_VARIANTS.body_strong_lg,
      color: `${COLORS.BLACK} !important`,
      fontSize: "16px !important",
      fontWeight: "400 !important",
      lineHeight: "140% !important",
      marginTop: "1px",
      whiteSpace: "nowrap"
    },
    // Override sd-element--with-frame to remove unwanted drop shadow
    "& .sd-element--with-frame": {
      boxShadow: "none !important",
      border: "none !important",
      padding: "0 5px 0 5px !important"
    },
    // Nested panels get SurveyJS frame borders; strip around scrollable consent docs
    "& .sd-element--nested-with-borders:has(.terms-scrollable-panel), & .terms-scrollable-panel .sd-element--nested-with-borders":
      {
        border: "none !important",
        boxShadow: "none !important",
        paddingLeft: "10px !important",
        paddingRight: "0 !important"
      },
    // Choice pills (radio + checkbox) — sitewide via registerChoicePillQuestions
    "& .gl-choice-pill-list": {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      maxWidth: "100%",
      width: "fit-content"
    },
    "& .gl-choice-pill-list--wrap": {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "8px",
      width: "100%"
    },
    "& .gl-choice-pill": {
      alignItems: "center",
      backgroundColor: COLORS.BACKGROUND_BLUE,
      border: `1.5px solid transparent`,
      borderRadius: "20px",
      boxSizing: "border-box",
      display: "flex",
      gap: "4px",
      minHeight: "40px",
      padding: "0px 8px 0px 4px",
      position: "relative",
      transition:
        "background-color 0.15s ease, border-color 0.15s ease, border-radius 0.15s ease",
      width: "100%",
      "&:hover": {
        backgroundColor: COLORS.BACKGROUND_BLUE,
        borderColor: COLORS.PRIMARY_LIGHTER
      },
      "&.gl-choice-pill--selected": {
        backgroundColor: COLORS.PRIMARY_LIGHTEST,
        borderColor: COLORS.PRIMARY_40,
        borderRadius: "32px 32px 4px 32px",
        "&:hover": {
          backgroundColor: COLORS.PRIMARY_LIGHTEST,
          borderColor: COLORS.PRIMARY_40
        }
      }
    },
    "& .gl-choice-pill-list--wrap .gl-choice-pill": {
      backgroundColor: COLORS.WHITE,
      border: `2px solid ${COLORS.PRIMARY_LIGHTER}`,
      borderRadius: "999px",
      minHeight: "36px",
      padding: "0 4px 0 0",
      width: "auto",
      maxWidth: "100%",
      "&:hover": {
        backgroundColor: COLORS.WHITE,
        borderColor: COLORS.PRIMARY_LIGHT
      },
      "&.gl-choice-pill--selected": {
        backgroundColor: COLORS.PRIMARY_LIGHTEST,
        borderColor: `${COLORS.PRIMARY_LIGHT}`,
        borderRadius: "32px 32px 4px 32px",
        "&:hover": {
          backgroundColor: COLORS.PRIMARY_LIGHTEST,
          borderColor: COLORS.PRIMARY_40
        }
      }
    },
    "& .gl-choice-pill-list--wrap .gl-choice-pill__main": {
      flex: "0 1 auto",
      padding: "6px 16px 6px 12px"
    },
    "& .gl-choice-pill-list--wrap .gl-choice-pill:not(.gl-choice-pill--selected) .gl-choice-pill__main":
      {
        padding: "6px 16px 6px 20px"
      },
    "& .gl-choice-pill-list--wrap .gl-choice-pill--selected .gl-choice-pill__main":
      {
        gap: "8px"
      },
    "& .gl-choice-pill-list--wrap .gl-choice-pill__label": {
      flex: "0 1 auto",
      whiteSpace: "normal"
    },
    "& .gl-choice-pill__main": {
      alignItems: "center",
      background: "transparent",
      border: "none",
      borderRadius: "inherit",
      cursor: "pointer",
      display: "flex",
      flex: 1,
      gap: "0",
      minWidth: 0,
      padding: "5px 20px",
      textAlign: "left",
      transition: "padding 0.15s ease, gap 0.15s ease",
      "&:disabled": {
        cursor: "default"
      }
    },
    "& .gl-choice-pill--selected .gl-choice-pill__main": {
      gap: "12px"
    },
    "& .gl-choice-pill__check": {
      backgroundColor: COLORS.PRIMARY_40,
      backgroundImage: `url(${checkIcon})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "14px 14px",
      borderRadius: "50%",
      boxSizing: "border-box",
      flexShrink: 0,
      height: "16px",
      opacity: 0,
      overflow: "hidden",
      transition: "width 0.15s ease, opacity 0.15s ease",
      width: "0",
      "&.gl-choice-pill__check--visible": {
        opacity: 1,
        width: "16px"
      }
    },
    "& .gl-choice-pill__label": {
      ...TYPOGRAPHY_VARIANTS.body_strong_lg,
      color: `${COLORS.BLACK} !important`,
      flex: 1,
      fontSize: "16px !important",
      fontWeight: "400 !important",
      lineHeight: "140% !important",
      marginTop: "1px",
      minWidth: 0,
      overflowWrap: "break-word",
      whiteSpace: "normal",
      wordBreak: "break-word"
    },
    "& .gl-choice-pill__info-wrap": {
      flexShrink: 0,
      paddingRight: "0px",
      position: "relative"
    },
    "& .gl-choice-pill__info-btn": {
      color: `${COLORS.PRIMARY_LIGHT} !important`,
      padding: "6px !important"
    },
    // Legacy SurveyJS radio/checkbox (fallback if default renderer used)
    "& .sd-checkbox": {
      "& .sd-selectbase__label": {
        alignItems: "center"
      },
      "& .sd-item__control-label": {
        ...TYPOGRAPHY_VARIANTS.body_strong_lg
      },
      "&.sd-item, .sd-item__decorator": {
        boxShadow: "none"
      },
      "& .sd-item__control:focus + .sd-item__decorator": {
        background: "rgba(0,0,0,0)",
        border: "1px solid",
        borderColor: COLORS.SUCCESS
      },
      "& .sd-item__decorator.sd-checkbox__decorator": {
        border: "2px solid #CBD2E0",
        borderRadius: "4px"
      },
      "&.sd-checkbox--checked .sd-item__decorator.sd-checkbox__decorator": {
        backgroundImage: `url(${checkIcon})`,
        background: COLORS.BLACK,
        "--primary-foreground": "rgba(0,0,0,0)",
        backgroundPosition: "center center"
      },
      "& .sd-item__svg.sd-checkbox__svg": {
        display: "none"
      }
    },
    // Slider styling
    "& .sd-slider": {
      "& .sd-slider__label-tick": {
        display: "none"
      },
      "& .sd-slider__track": {
        height: "8px",
        "&:after, &:before": {
          height: "8px"
        },
        "&:before": {
          backgroundColor: COLOR_CONSTANTS.COLOR_INFO
        }
      },
      "& .sd-slider__range-track": {
        backgroundColor: COLOR_CONSTANTS.COLOR_INFO
      },
      "& .sd-slider__thumb-container": {
        top: "2px"
      },
      "& .sd-slider__thumb": {
        backgroundColor: COLOR_CONSTANTS.COLOR_INFO
      },
      "& .sd-slider__thumb-dot": {
        backgroundColor: COLOR_CONSTANTS.COLOR_INFO
      },
      "& .sd-slider-labels-container": {
        //margin: "0"
      },
      // Make all labels smaller at narrow widths
      "& .sd-slider__label .sd-slider__label-text": {
        "@media (max-width: 520px)": {
          fontSize: "12px !important"
        }
      }
    },
    // Radio group styling - match checkbox styling exactly
    "& .sd-radio": {
      "& .sd-selectbase__label": {
        alignItems: "center"
      },
      "& .sd-item__control-label": {
        ...TYPOGRAPHY_VARIANTS.body_strong_lg
      },
      "&.sd-item, .sd-item__decorator": {
        boxShadow: "none"
      },
      "&.sd-radio--checked": {
        //border: 0
      },
      "& .sd-item__control:focus + .sd-item__decorator": {
        background: "rgba(0,0,0,0)",
        border: "1px solid",
        borderColor: COLORS.SUCCESS
      },
      "& .sd-item__decorator.sd-radio__decorator": {
        border: "2px solid #CBD2E0",
        borderRadius: "4px",
        "&:after": {
          display: "none"
        }
      },
      "&.sd-radio--checked .sd-item__decorator.sd-radio__decorator": {
        backgroundImage: `url(${checkIcon})`,
        background: COLORS.BLACK,
        "--primary-foreground": "rgba(0,0,0,0)",
        backgroundPosition: "center center"
      },
      "& .sd-item__svg.sd-radio__svg": {
        display: "none"
      }
    },
    "& #informed-consent-survey": {
      "& .sd-container-modern": {
        height: "100%"
      }
    }
  },
  surveyContainerFillViewport: {
    flex: "1 1 0%",
    height: 0,
    marginBottom: "0 !important",
    minHeight: 0,
    overflow: "hidden",
    width: "100%",
    // SurveyJS 2 hides its own scrollbar and clips if we force inner
    // .sv-scroll__* wrappers to height 100% / overflow hidden. Let content
    // grow and scroll on the React slot (#surveyId) instead.
    // flex-shrink: 0 keeps the white card as tall as the questions so it
    // cannot collapse and leave content sitting on the page gradient.
    "& .sd-root-modern, & .sd-root-modern.sd-root-modern--full-container": {
      flexShrink: 0,
      height: "auto !important",
      maxHeight: "none",
      minHeight: "100%",
      overflow: "visible !important",
      width: "100%"
    },
    "& .sd-root-modern__wrapper": {
      flexShrink: 0,
      height: "auto",
      marginTop: 0,
      overflow: "visible",
      width: "100%"
    },
    "& .sv-scroll__wrapper, & .sv-scroll__scroller, & .sv-scroll__container": {
      flex: "none",
      flexShrink: 0,
      height: "auto !important",
      maxHeight: "none",
      overflow: "visible !important",
      width: "100%"
    },
    "& .sd-container-modern": {
      backgroundColor: "transparent",
      borderRadius: 0,
      flexShrink: 0,
      height: "auto !important",
      maxHeight: "none",
      minHeight: "100%",
      overflow: "visible"
    },
    "& .sd-navigation__next-btn, & .sd-navigation__complete-btn": {
      display: "none !important"
    },
    "& .sd-navigation__next-btn.gl-nav-visible, & .sd-navigation__complete-btn.gl-nav-visible":
      {
        display: "flex !important"
      },
    "& .sd-navigation__next-btn.gl-nav-visible:disabled, & .sd-navigation__complete-btn.gl-nav-visible:disabled":
      {
        display: "none !important"
      },
    "& #sv-nav-next:not(:has(.gl-nav-visible)), & #sv-nav-complete:not(:has(.gl-nav-visible))":
      {
        display: "none"
      }
  },
  formTemplateContainer: {
    minHeight: "400px",
    marginBottom: "0px !important",
    "& .sd-container-modern": {
      minHeight: "400px",
      height: "auto",
      overflowY: "visible",
      padding: "0 0 10px 0"
    },
    "& .sd-panel__content": {
      padding: "0"
    },
    "& .sd-page, & .sd-body": {
      padding: "0px  ! important"
    },
    "& h1": {
      fontSize: "24px",
      lineHeight: "28px",
      margin: "0"
    },
    "& .gl-form-page-title": {
      color: COLORS.PRIMARY,
      fontFamily: "Inter, sans-serif",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: 700,
      letterSpacing: "-0.5px",
      lineHeight: "125%",
      margin: "0 0 16px",
      textAlign: "left",
      [theme.breakpoints.up("md")]: {
        fontSize: "28px"
      }
    },
    "& h3": {
      fontSize: "20px !important",
      lineHeight: "24px",
      color: `${COLORS.BLACK} !important`,
      margin: "0 !important"
    },
    "& h4": {
      fontSize: "15px",
      lineHeight: "19px",
      margin: "0"
    },
    "& .terms-scrollable-panel": {
      border: "none",
      borderRadius: "0",
      padding: "0 2px",
      overflow: "visible !important",
      height: "auto !important",
      maxHeight: "510px !important",
      "& .sd-panel": {
        padding: "0 10px !important"
      }
    },
    "& .terms-scrollable-panel__content": {},
    "& .sd-error": {
      width: "100%",
      margin: "0",
      borderRadius: "0"
    },
    "& .terms-checkbox-with-button .MuiBox-root": {
      margin: "20px 0"
    }
  }
}));

export default SurveyWrapperStyles;
